"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrdinalStringForNumber = void 0;
/**
 * Returns an ordinal string representation of a number.
 * Hopefully support will be added to the Intl API in future.
 * @hidden
 * @param value The numerical value to be formatted.
 * @returns An ordinal string representation of the number.
 */
var getOrdinalStringForNumber = function (value) {
    var absValue = Math.abs(value);
    var rem10 = absValue % 10;
    var rem100 = absValue % 100;
    if (rem10 === 1 && rem100 !== 11)
        return value + 'st';
    if (rem10 === 2 && rem100 !== 12)
        return value + 'nd';
    if (rem10 === 3 && rem100 !== 13)
        return value + 'rd';
    return value + 'th';
};
exports.getOrdinalStringForNumber = getOrdinalStringForNumber;
//# sourceMappingURL=get-ordinal-string-for-number.js.map